export class GetVaultResponse {
    'vault';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vault",
            "baseName": "vault",
            "type": "BackupVault",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetVaultResponse.attributeTypeMap;
    }
    constructor() {
    }
}
